import { TableColumn } from "../table/TableColumn";

const PresetParameterColumn: TableColumn[] = [
    {
        heading: "Name",
        accessor: "name",
        isNumeric: false,
        id: 0,
        sortByName: "trnName",
        sortDirection: "asc",
        active: true,
        translationKey: "name"
    }
];

export default PresetParameterColumn
    ;
